import * as React from "react";
import styled from "styled-components";

import { NavItemPropTypes } from "../../vars";
import OverlayMenu from "./OverlayMenu";
import { OverlayCollapsibleLabel } from "./OverlayCollapsibleLabel";

const propTypes = {
  ...NavItemPropTypes,
};

const OverlayCollapsible: React.SFC<any> = ({
  className,
  itemRef,
  label,
  menuItems,
  onToggle,
  open,
  itemKey,
}) => (
  <div className={className} ref={itemRef}>
    <OverlayCollapsibleLabel
      role="collapsibleToggle"
      open={open}
      icon={label.icon}
      onClick={() => onToggle(open, itemKey)}
    >
      {label.text}
    </OverlayCollapsibleLabel>
    <div role="collapsibleContent">
      {open && <OverlayMenu items={menuItems} />}
    </div>
  </div>
);

OverlayCollapsible.propTypes = propTypes;

export default styled(OverlayCollapsible)`
  background: ${(p) => p.theme.colors.white};
`;
